var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card mx-auto mt-5 card-width shadow" }, [
    _c("div", { staticClass: "card-body text-secondary" }, [
      _c("h5", { staticClass: "card-text font-weight-bold mb-1" }, [
        _vm._v("\n      Drivers love us\n    ")
      ]),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "card-text" },
        [
          _vm._v("\n      4.9 Google\n      "),
          _c("br"),
          _vm._v(" "),
          _c("font-awesome-icon", {
            staticClass: "rg-grey",
            attrs: { icon: ["fas", "star"] }
          }),
          _vm._v(" "),
          _c("font-awesome-icon", {
            staticClass: "rg-grey",
            attrs: { icon: ["fas", "star"] }
          }),
          _vm._v(" "),
          _c("font-awesome-icon", {
            staticClass: "rg-grey",
            attrs: { icon: ["fas", "star"] }
          }),
          _vm._v(" "),
          _c("font-awesome-icon", {
            staticClass: "rg-grey",
            attrs: { icon: ["fas", "star"] }
          }),
          _vm._v(" "),
          _c("font-awesome-icon", {
            staticClass: "rg-grey",
            attrs: { icon: ["fas", "star"] }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("h5", { staticClass: "card-text font-weight-bold mb-1" }, [
        _vm._v("\n      Over 7 billion borrowed\n    ")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "card-text" }, [
        _vm._v("\n      20 years of helping customers save\n    ")
      ]),
      _vm._v(" "),
      _c("h5", { staticClass: "card-text font-weight-bold mb-1" }, [
        _vm._v("\n      We're ready to help\n    ")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "card-text" }, [
        _c("a", { attrs: { href: "tel:" + _vm.phoneNumber } }, [
          _vm._v(_vm._s(_vm.phoneNumber))
        ]),
        _vm._v(" or\n      "),
        _c(
          "a",
          {
            staticClass: "text-decoration-none rg-grey",
            attrs: { href: "mailto:" + _vm.emailAddress }
          },
          [_vm._v("\n        " + _vm._s(_vm.emailAddress) + "\n      ")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }